import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { ITableService, IFilterValues } from '../../../services/tables/interfaces/table.service.interface';
import { INotification } from '../../notifications-menu/services/notifications/notifications-service.interface';
import { INotifications } from './notifications.service.interface';

@Injectable()
export class NotificationsService implements INotifications {
  constructor(@Inject('ITableService') public tableService: ITableService) {}

  public isLoading = true;
  public totalItems = 0;
  public limit = 5;

  getNotificationsData(activeTab: { [key: string]: string }, page = 1, filters: IFilterValues = {}): Observable<INotification[]> {
    this.isLoading = true;
    this.totalItems = 0;
    let notifications$: Observable<INotification[]>;

    if (activeTab.Incidents) {
      switch (activeTab.Incidents) {
        case 'Default':
          notifications$ = this.tableService.getData('IncidentsTable', page, this.limit, filters, {}).pipe(
            tap(({ total }) => (this.totalItems = total)),
            map((data) => data.rows as INotification[])
          );
          break;
      }
    }

    if (activeTab.Notifications) {
      switch (activeTab.Notifications) {
        case 'Master':
          notifications$ = this.tableService.getData('NotificationsTable', page, this.limit, filters, {}).pipe(
            tap(({ total }) => (this.totalItems = total)),
            map((data) => data.rows as INotification[])
          );
          break;

        case 'Affiliates':
          notifications$ = this.tableService
            .getData(
              'CrmNotificationsTable',
              page,
              this.limit,
              {
                ...filters,
                event: [
                  'NEW_AFFILIATE_SIGNUP',
                  'NEW_AFFILIATE_TRACKER',
                  'NEW_GLOBAL_POSTBACK',
                  'AFFILIATE_PAYMENT_DETAIL',
                  'NEW_AFFILIATE_INVOICE',
                  'AFFILIATE_OFFER_ACCESS',
                  'NEW_AFFILIATE_REQUEST_TOKEN',
                  'AFFILIATE_CONFIRM',
                  'ACTIVATE_AFFILIATE',
                ],
              },
              {}
            )
            .pipe(
              tap(({ total }) => (this.totalItems = total)),
              map((data) => data.rows as INotification[])
            );
          break;

        case 'Conversions':
          notifications$ = this.tableService
            .getData(
              'CrmNotificationsTable',
              page,
              this.limit,
              {
                ...filters,
                event: ['NEW_CONVERSION'],
              },
              {}
            )
            .pipe(
              tap(({ total }) => (this.totalItems = total)),
              map((data) => data.rows as INotification[])
            );
          break;
      }
    }
    return notifications$.pipe(tap(() => (this.isLoading = false)));
  }
}
